import { graphql } from "../gql";

export const query = graphql(`
    query AppTermsQuery {
        terms {
            terms
            settingsTerms
        }
    }
`);
